import { useGetPieListQuery } from "../../../redux/api/3+2";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { PieChartPiece } from "../../../models/ThreePlusTwo/threePlusTwo";
import styles from './styles.module.css';
import { HeaderSide } from "./headerside";
import { SelectYear } from "../../../components/selects";
import { useState } from 'react';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FFC658', '#FF7C7C', '#8DD1E1', '#D084D0'];

interface ChartData {
  name: string;
  value: number;
  percent: number;
}

const transformDataForChart = (pieces: PieChartPiece[]): ChartData[] => {
  return pieces.map(piece => ({
    name: piece.nameRu,
    value: piece.value,
    percent: piece.percent
  }));
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className={styles.tooltip}>
        <p>{data.name}</p>
        <p>Значение: {data.value}</p>
        <p>Процент: {data.percent.toFixed(2)}%</p>
      </div>
    );
  }
  return null;
};

export const GraphPirog = () => {
  const [selectedYear, setSelectedYear] = useState<number>(2025);
  const { data, isLoading, error } = useGetPieListQuery({ year: selectedYear });

  if (isLoading) return <div className={styles.loading}>Загрузка...</div>;
  if (error) return <div className={styles.error}>Ошибка загрузки данных</div>;
  if (!data?.res) return <div className={styles.noData}>Нет данных</div>;

  const chartSections = [
    { key: 'zadachiPoJivotnovodstvu', title: 'Задачи по животноводству' },
    { key: 'zadachiPoRastenievodstvu', title: 'Задачи по растениеводству' },
    { key: 'kolichestvoFermerov', title: 'Количество фермеров' },
    { key: 'kolichestvoGektarPoKulturam', title: 'Количество гектар по культурам' },
    { key: 'kolichestvoEdinicTechniki', title: 'Количество единиц техники' },
    { key: 'kolichestvoJivotnyh', title: 'Количество животных' },
    { key: 'kolichestvoObektovNedvijnosti', title: 'Количество объектов недвижимости' }
  ];

  return (
    <div className={styles.container}>
      <HeaderSide />
      <div className={styles.headerControls}>
        <SelectYear
          value={selectedYear}
          onChange={(value) => value && setSelectedYear(value)}
        />
      </div>
      <div className={styles.chartsGrid}>
        {chartSections.map((section, index) => {
          const sectionData = data.res[section.key as keyof typeof data.res];
          const chartData = transformDataForChart(sectionData.pieces);

          // Не показываем график если total равен 0 или pieces пустой
          if (sectionData.total === 0 || sectionData.pieces.length === 0) {
            return null;
          }

          return (
            <div key={section.key} className={styles.chartContainer}>
              <h3 className={styles.chartTitle}>{section.title}</h3>
              <div className={styles.totalInfo}>
                Общее количество: {sectionData.total}
              </div>
              <div className={styles.chartWrapper}>
                <ResponsiveContainer width="70%" height={300}>
                  <PieChart>
                    <Pie
                      data={chartData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ percent }) => `${percent.toFixed(1)}%`}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {chartData.map((entry, entryIndex) => (
                        <Cell key={`cell-${entryIndex}`} fill={COLORS[entryIndex % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                  </PieChart>
                </ResponsiveContainer>
                <div className={styles.legendContainer}>
                  {chartData.map((entry, entryIndex) => (
                    <div key={`legend-${entryIndex}`} className={styles.legendItem}>
                      <div
                        className={styles.legendColor}
                        style={{ backgroundColor: COLORS[entryIndex % COLORS.length] }}
                      ></div>
                      <div className={styles.legendTextContainer}>
                        <span className={styles.legendText}>{entry.name}</span>
                        <span className={styles.legendPercent}>{entry.percent.toFixed(1)}%</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};